import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { find, isString } from 'lodash';
import { isVoid } from '@/utils/common';
import Editable from '@/components/Editable';
import Tip from '../Tip';
import BadgeStatus from '../BadgeStatus';

/**
 * @typedef {'date' | 'datetime' | 'dateMillionTime' | 'options' | 'statusOptions'} typeEnum
 */

/**
 * @param {Object} props
 * @param {*} props.label 标题
 * @param {*} [props.tip] 提示
 * @param {*} props.value 内容
 * @param {Object} [props.labelStyle]
 * @param {Object} [props.valueStyle]
 * @param {*} props.value
 * @param {*} [props.options] options
 * @param {*} [props.emptySuffix] 空值后缀
 * @param {typeEnum} props.type 类型
 * @param {boolean} props.editable 是否可编辑，暂未实现关联type
 * @param {func} props.onChange 编辑回调
 * @param {func} props.render 自定义编辑模式下渲染value
 * @param {number} [props.span] 包含列的数量 默认1 Descriptions.Item情况下可用
 */
export default function DescriptionItem({
  label,
  value,
  labelStyle,
  type,
  tip,
  valueStyle,
  editable,
  onChange,
  emptySuffix,
  options,
  render,
}) {
  let val = useMemo(() => {
    if (type) {
      if (type === 'date') {
        return isVoid(value) ? '' : dayjs(value).format('YYYY-MM-DD');
      }
      if (type === 'datetime') {
        return isVoid(value) ? '' : dayjs(value).format('YYYY-MM-DD HH:mm:ss');
      }
      if (type === 'dateMillionTime') {
        return isVoid(value) ? '' : dayjs(value).format('YYYY-MM-DD HH:mm:ss.SSS');
      }
      if (type === 'options') {
        return find(options || [], { value })?.label;
      }
      if (type === 'statusOptions') {
        const found = find(options || [], { value });
        return <BadgeStatus {...found} />;
      }
    }
    return value;
  }, [type, value, options]);

  if (isVoid(val) && emptySuffix) {
    val = emptySuffix;
  }

  const valText = value ? (isString(value) ? value : '') : '';

  return (
    <Root>
      <Label className='description-label' style={labelStyle}>
        <Tip content={tip}>{label}</Tip>
      </Label>
      <Value title={valText} className='description-value' style={valueStyle}>
        {editable ? <Editable render={render} text={value} onChange={onChange} /> : val}
      </Value>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  min-width: 0;
`;

const Label = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: var(--td-font-gray-2);
  padding-right: 10px;
`;

const Value = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: var(--td-font-gray-1);
  overflow: hidden;
  word-break: break-all;
  min-width: 0;
  flex: 1;
  padding-right: 10px;
`;
